/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Slot_Move_DownInputs */

const en_slot_move_down = /** @type {(inputs: Slot_Move_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Move ${i?.name} down`)
};

const de_slot_move_down = /** @type {(inputs: Slot_Move_DownInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} nach unten`)
};

/**
* | output |
* | --- |
* | "Move {name} down" |
*
* @param {Slot_Move_DownInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const slot_move_down = /** @type {((inputs: Slot_Move_DownInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Slot_Move_DownInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_slot_move_down(inputs)
	return en_slot_move_down(inputs)
});